import React, { useEffect, useState } from "react";
import { Flex, notification, Typography, Statistic } from "antd";
import { CustomSpinner, CustomTable } from "../../utils/CustomComponents";
import { api } from "../../utils/Api";
import axios from "axios";
import dayjs from "dayjs";
const { Text } = Typography;

/**
 ** Options header (columns)
 */
const columns = [
	{
		title: "# Ticket",
		dataIndex: "ticket",
		key: "ticket",
		render: (value) => <Text>{value}</Text>,
	},
	{
		title: "Material",
		dataIndex: "material",
		key: "material",
		render: (value) => <Text>{value}</Text>,
	},
	{
		title: "Quantity",
		dataIndex: "quantity",
		key: "quantity",
		render: (value) => <Text>{value}</Text>,
	},
	{
		title: "Supplier",
		dataIndex: "supplier",
		key: "supplier",
		render: (value) => <Text>{value}</Text>,
	},
	{
		title: "# Truck",
		dataIndex: "truck",
		key: "truck",
		render: (value) => <Text>{value}</Text>,
	},
	{
		title: "Registration Date",
		dataIndex: "registrationDate",
		key: "registrationDate",
		render: (value) => <Text>{value}</Text>,
	},
	{
		title: "Received Date",
		dataIndex: "receivedDate",
		key: "receivedDate",
		render: (value) => <Text>{value}</Text>,
	},
	{
		title: "Batcher",
		dataIndex: "batcher",
		key: "batcher",
		render: (value) => <Text>{value}</Text>,
	},
];

const ReceptionDetailsByMaterial = ({ plant, date, materialId }) => {
	const [loading, setLoading] = useState(true);
	const [list, setList] = useState([]);

	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getReceptionsByMaterial();
	}, []);

	const getReceptionsByMaterial = async () => {
		try {
			setLoading(true);
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const year = dayjs(date).year();
			const month = dayjs(date).month() + 1;

			const url =
				api +
				`/reception/get/list/bymaterial?year=${year}&month=${month}&plant=${plant}&material=${materialId}`;
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						ticket: item.ticket,
						material: item.material.material,
						quantity: `${item.quantity} ${item.material.inventoryUnitOfMeasurement}`,
						supplier: item.supplier.name,
						truck: item.truck,
						registrationDate: dayjs(item.createdAt).format("MM/DD/YYYY HH:mm"),
						receivedDate: dayjs(item.receivedDate).format("MM/DD/YYYY HH:mm"),
						batcher: item.batcher ? item.batcher.name : "N/A",
					});
				});
				setList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			openNotification(
				"error",
				"Error",
				"Something went wrong while obtaining receptions"
			);
			console.error(err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<CustomTable columns={columns} data={list} isScroll={false} />
			</Flex>
		);
	};

	return (
		<Flex vertical gap={"large"}>
			{loading ? <CustomSpinner /> : <RenderTable />}
			{contextHolder}
		</Flex>
	);
};

export default ReceptionDetailsByMaterial;
